const link = (scope, element, attrs) => {
  const TAB_KEY_CODE = 9;

	scope.executeOnTab = ($event) => {
    if($event.keyCode === TAB_KEY_CODE) {
      scope.onTab();
    }
  };
  scope.setRefId = () => {
    if (scope.model.refIdObj && scope.model.refIdObj.id) {
      scope.model.refId = scope.model.refIdObj.id;
      scope.model.locationType = scope.model.refIdObj.locationType;
    }
  }

    scope.amountModel = {};
    scope.activeField = null;

    scope.getCoinValue = (group) => {
        if (!scope.coinValues || !scope.denominationTypeObj || !scope.denominationTypeObj.coinTypes[group]) return 0;
        let selected = scope.denominationTypeObj.coinTypes[group].selected;
        let val = scope.coinValues[selected];
        if (!val) return 0;
        return (val.amountFlag && val.amount > 0) ? val.amount : val.unitValue;
    };

    scope.syncAmountModel = () => {
        if (!scope.model || !scope.denominationTypeObj) return;
        scope.denominationTypeObj.denomTypes.forEach((key) => {
            let catName = scope.denominationTypeObj.coinTypes[key.group].categoryName;
            if (scope.activeField === catName) return;

            let unitValue = scope.getCoinValue(key.group);
            let unitCount = scope.model[catName];

            if (unitCount != null && unitCount !== '') {
                scope.amountModel[catName] = (unitCount * unitValue).toFixed(2);
                if (unitCount % 1 !== 0) {
                    if (!scope.model.amountErrors) scope.model.amountErrors = {};
                    scope.model.amountErrors[catName] = true;
                } else if (scope.model.amountErrors) {
                    delete scope.model.amountErrors[catName];
                }
            } else if (!scope.model.amountErrors || !scope.model.amountErrors[catName]) {
                scope.amountModel[catName] = null;
            }
        });
    };

    scope.calculateCoinOnlyTotal = () => {
        if (!scope.coinOnlyBatch || !scope.model || !scope.denominationTypeObj) return;
        let total = 0;
        scope.denominationTypeObj.denomTypes.forEach((key) => {
            let catName = scope.denominationTypeObj.coinTypes[key.group].categoryName;
            let unitValue = scope.getCoinValue(key.group);
            let unitCount = scope.model[catName];
            if (unitCount != null && unitCount !== '') {
                total += unitCount * unitValue;
            }
        });
        scope.model.total = total;
    };

    scope.onAmountFocus = (catName) => {
        scope.activeField = catName;
    };

    scope.onAmountBlur = () => {
        scope.activeField = null;
        scope.syncAmountModel();
    };

    scope.$watch('model', (newVal, oldVal) => {
        scope.syncAmountModel();
        if (scope.coinOnlyBatch) {
            scope.calculateCoinOnlyTotal();
        }
    }, true);
    scope.$watch('amountToggle', scope.syncAmountModel);
    scope.$watch('denominationTypeObj', scope.syncAmountModel, true);

    scope.onAmountChange = (catName, group) => {
        let unitValue = parseFloat(scope.getCoinValue(group));
        let amtStr = scope.amountModel[catName];

        if (amtStr !== null && amtStr !== undefined && amtStr !== '') {
            let val = parseFloat(amtStr);
            if (!isNaN(val) && unitValue > 0) {
                let remainder = Math.abs((val / unitValue) - Math.round(val / unitValue));
                if (remainder < 0.0001) {
                    scope.model[catName] = Math.round(val / unitValue);
                    if (scope.model.amountErrors) delete scope.model.amountErrors[catName];
                } else {
                    scope.model[catName] = null;
                    if (!scope.model.amountErrors) scope.model.amountErrors = {};
                    scope.model.amountErrors[catName] = true;
                }
            } else {
                scope.model[catName] = null;
                if (!scope.model.amountErrors) scope.model.amountErrors = {};
                scope.model.amountErrors[catName] = true;
            }
        } else {
            scope.model[catName] = null;
            if (scope.model.amountErrors) delete scope.model.amountErrors[catName];
        }
    };
};

export default link;



// WEBPACK FOOTER //
// ./client/app/components/shipment_batch/shipment_record/shipment_record.link.js